export default [
    {
        path: '/prerequisite/part-origins',

        name: 'Part Origins',

        component: () => import('@/views/prerequisite/part-origins'),
    },
];